import React from "react";
import KeywordsTag from './KeywordsTag';

const ChateauTimo = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="chateautimopublic"
        handwritingSrc="../../content/handwriting/chateau-timo-02.png"
        handwritingAlt="Chateau Timo"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default ChateauTimo;